import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import Main from "containers/main/index";
import { enumLang } from "./lang/config";
import { getCookie } from "utils/getCookie";
import "./lang/config";
import "./App.css";
import { PagProvider } from "containers/pagProvider";
if (process.env.NODE_ENV === "development") {
  window.cookie_list = {
    b_notify: "1",
    countryId: "37",
    curr_fiat: "CNY",
    lang: "cn",
    // lang: "en",
    last_lang: "cn",
    lasturl: "/",
    login_notice_check: "/",
    market_title: "usdt",
    t_token: "b66d7bbff8e3e54bbae5a34f9b262367",
    uid: "110280983",
    _ym_d: "1669707380",
    _ym_isad: "2",
    _ym_uid: "1669707380270355853",
    _ym_visorc: "b",
    nickname: "kirk",
    avatar:
      "https://gavatar.gateimg.com/groupchat/avatar-80dd5d588d-cbbd11bf47-3a8241-d3d944?w=3840&q=75",
    pver: "53ad5e869eb00d40e338ed816e79f6e8",
    // 0 未知、1 男、2 女
    gender: 1,
  };
}
function App() {
  const { t } = useTranslation();

  window.t = t;

  // 因为smarting 的占位符不支持双括号：{{}} ，所以换成了与主站一致的 $$
  window.t = (key, arr_replace) => {
    let result = t(key);
    try {
      if (arr_replace) {
        if (Object.prototype.toString.call(arr_replace) === "[object Array]") {
          arr_replace.forEach(function (replaceElement, index) {
            result = result.replace("$" + index + "$", replaceElement);
          });
        }
        if (Object.prototype.toString.call(arr_replace) === "[object Object]") {
          Object.keys(arr_replace).forEach(function (item) {
            result = result.replace("$" + item + "$", arr_replace[item]);
            if (result.includes(`$ ${item} $`)) {
              result = result.replace("$ " + item + " $", arr_replace[item]);
            }
          });
        }
      }
    } catch (error) {
      result = key;
    }
    return result;
  };

  // 判断是否移动端
  function isMobile() {
    try {
      document.createEvent("TouchEvent");
      return true;
    } catch (e) {
      return false;
    }
  }

  window.$$isMobile = isMobile();

  // 判断是否移动端，则跳转唤醒App端 link；否则不跳转
  // 开发环境不跳
  // if (process.env.NODE_ENV === "production") {
  //   if (window.$$isMobile && !Number(getCookie("device_type") || 0)) {
  //     window.$$can_awake_up_app = true;
  //     window.$$awake_target = "https://gateio-banner.onelink.me/HBnE/4b8k246r";
  //   } else {
  //     window.$$can_awake_up_app = false;
  //   }
  // }

  useEffect(() => {
    setLang(); // 设置全局语言

    forbiddenAppRefresh();
    if (process.env.NODE_ENV === "development" && window.$$isMobile) {
      window.$$device_type = 1;
    }
  }, []);

  // 禁止App端下拉刷新
  const forbiddenAppRefresh = () => {
    try {
      if (+window.$$device_type === 1) {
        window.gateio?.disableNativeRefresh?.();
      } else if (+window.$$device_type === 2) {
        window.webkit?.messageHandlers?.disableNativeRefresh?.postMessage?.(
          null,
        );
      }
    } catch {
      console.log("forbiddenAppRefresh failed");
    }
  };

  const setLang = () => {
    const lang = window.location.pathname.split("/")[1];
    if (window.$$g_lang) {
      window.g_lang = window.$$g_lang;
      // 中文与越南语需要单独处理
      if (window.$$g_lang === "cn") {
        window.g_lang = "zh";
      } else if (window.$$g_lang === "vi") {
        window.g_lang = "vn";
      }
    } else {
      window.g_lang = "en";
      if (lang.length === 2) {
        for (let ele in enumLang) {
          if (enumLang[ele] === lang) {
            window.g_lang = enumLang[ele];
            break;
          }
        }
      }
    }
    if (lang === "zh-tw") {
      window.g_lang = "tw";
    }
    i18next.changeLanguage(window.g_lang);

    // ar小语种兼容；
    if (window.g_lang === "ar") {
      const body = document.querySelector("body");
      body.classList.add("ar_fix");
    }
  };

  // window.$$u_id = getCookie('u_id')
  window.$$uid = getCookie("uid");
  // appLang 只能拿到app端的语言，需要处理中文和越南语
  window.$$g_lang = getCookie("appLang") || getCookie("lang");
  window.$$is_phone = getCookie("is_phone");
  // 设备类型： device_type === 1 ? android : ios
  window.$$device_type = Number(getCookie("device_type") || 0);
  window.$$sign = getCookie("sign");
  // 金刚区里面的配置
  window.$$is_show_title = getCookie("is_show_title") || 0;
  return (
    <PagProvider>
      <Main />
    </PagProvider>
  );
}

export default App;
